import React from 'react';
import Link from 'next/link';

const RightChevron = () => (
  <svg
    className="h-4 w-auto text-gray-500 mx-2 transform -rotate-90"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      d="M5.293 6.707a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
      clipRule="evenodd"
    ></path>
  </svg>
);

interface IProps {
  prizeCategoryName?: string;
  prizeCategoryHref?: string;
  prizeName?: string;
  className?: string;
}

export const PrizePageNav = ({
  prizeCategoryName,
  prizeCategoryHref,
  prizeName = undefined,
  className = undefined,
}: IProps) => {
  const withPrizeCategoryElement = !!prizeCategoryName && !!prizeCategoryHref;
  const withPrizeName = !!prizeName;
  return (
    <div className={className}>
      <nav className="text-xs px-1 lg:px-2">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link href="/">
              <a
                style={{ textShadow: 'none' }}
                className="text-gray-500 font-medium !drop-shadow-none"
              >
                Home
              </a>
            </Link>
            <RightChevron />
          </li>

          <li className="flex items-center">
            <Link href="/prizes">
              <a
                style={{ textShadow: 'none' }}
                className={
                  withPrizeCategoryElement
                    ? 'text-gray-500 font-medium !drop-shadow-none'
                    : 'text-gray-800 font-bold drop-shadow-none'
                }
              >
                Prizes
              </a>
            </Link>
            {withPrizeCategoryElement && <RightChevron />}
          </li>

          {withPrizeCategoryElement && (
            <li className="flex items-center">
              <Link href={prizeCategoryHref}>
                <a
                  style={{ textShadow: 'none' }}
                  className={
                    withPrizeName
                      ? 'text-gray-500 font-medium !drop-shadow-none'
                      : 'text-gray-800 font-bold drop-shadow-none'
                  }
                >
                  {prizeCategoryName}
                </a>
              </Link>
              {withPrizeName && <RightChevron />}
            </li>
          )}

          {withPrizeName && (
            <li className="flex items-center">
              <a
                style={{ textShadow: 'none' }}
                className="text-gray-800 font-bold drop-shadow-none"
              >
                {prizeName}
              </a>
            </li>
          )}
        </ol>
      </nav>
    </div>
  );
};
